import React from 'react'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import sharedSettings from 'shared/src/settings'

const units = sharedSettings.units

const project = [
  {
    id: 'name',
    title: 'Name',
    helperText: 'Enter the project name',
    default: '',
    validate: {
      type: 'string',
      methods: [
        ['required', 'Required'],
      ],
    },
  },
  [
    [
      'Currency',
      {
        id: 'meta.currency.symbol',
        title: 'Currency Symbol',
        default: '£',
        helperText: 'The currency to use for displaying money values',
      },
      {
        id: 'meta.currency.vat',
        title: 'VAT',
        default: 20,
        helperText: 'The percentage VAT applicable in your country',
      },
      'Markup',
      {
        id: 'meta.markup.materials',
        title: 'Materials',
        default: 40,
        helperText: 'The percentage markup to add to materials',
      },
      {
        id: 'meta.markup.labour',
        title: 'Labour',
        default: 30,
        helperText: 'The percentage markup to add to labour',
      },
      {
        id: 'meta.markup.hire',
        title: 'Hire',
        default: 30,
        helperText: 'The percentage markup to add to materials',
      },
      {
        id: 'meta.markup.waste',
        title: 'Waste',
        default: 30,
        helperText: 'The percentage markup to add to waste',
      },
      {
        id: 'meta.markup.misc',
        title: 'Misc',
        default: 30,
        helperText: 'The percentage markup to add to misc',
      },
    ],
    [
      'Company',
      {
        id: 'meta.company.name',
        title: 'Name',
        helperText: 'The name for your company',
      },
      {
        id: 'meta.company.email',
        title: 'Email',
        helperText: 'The email for your company',
      },
      {
        id: 'meta.company.phone',
        title: 'Phone',
        helperText: 'The phone number of your company',
      },
      {
        id: 'meta.company.vat',
        title: 'VAT Number',
        helperText: 'The VAT number of your company',
      },
      {
        id: 'meta.company.address',
        title: 'Address',
        helperText: 'The address of your company',
        component: 'textarea',
        rows: 5,
      },
      {
        id: 'meta.company.logo',
        title: 'Logo',
        helperText: 'The logo of your company',
        component: 'file',
        path: 'logos',
      },
    ]
  ],
  'Custom Units',
  [{
    id: 'meta.units',
    title: 'A list of custom units',
    helperText: 'Add custom units that can be used for resources',
    default: [],
    list: {
      mainField: 'name',
      schema: [{
        id: 'title',
        title: 'Name',
        helperText: 'The name of the unit',
        component: 'text',
        default: '',
        validate: {
          type: 'string',
          methods: [
            ['required', 'Required'],
          ],
        },
      },{
        id: 'unit',
        title: 'Code',
        helperText: 'The code of the unit',
        component: 'text',
        default: '',
        validate: {
          type: 'string',
          methods: [
            ['required', 'Required'],
          ],
        },
      }],
      table: [{
        title: 'Name',
        name: 'title',
      },{
        title: 'Code',
        name: 'unit',
      }]
    }
  }, (
    <div style={{
      marginTop: '10px',
    }}>
      <Typography>Standard Units</Typography>
      <Divider 
        style={{
          marginTop: '10px',
          marginBottom: '10px',
        }}
      />
      <div>
        <Typography
          style={{
            fontSize: '0.8em',
            color: '#999',
          }}
        >
          {
            units.all.map((unit, i) => {
              return (
                <span key={ i } style={{
                  paddingRight: '10px',
                }}>
                  { unit.title } ({ unit.unit })
                </span>
              )
            })
          }
        </Typography>
      </div>
    </div>
  )],
  'Project Types',
  [{
    id: 'meta.projectTypes',
    title: 'A list of project types',
    helperText: 'Add a list of types for a project',
    list: {
      mainField: 'name',
      sortBy: 'name',
      schema: [{
        id: 'name',
        title: 'Name',
        helperText: 'The name of the project type',
        component: 'text',
        default: '',
        validate: {
          type: 'string',
          methods: [
            ['required', 'Required'],
          ],
        },
      }],
      table: [{
        title: 'Name',
        name: 'name',
      }]
    }
  }, ''],
]

export default project